import Argentina from "./Argentina.jpg";
import Australia from "./Australia.jpg";
import Austria from "./Austria.jpg";
import Bahrain from "./Bahrain.jpg";
import Bangladesh from "./Bangladesh.jpg";
import Belgium from "./Belgium.jpg";
import Bermuda from "./Bermuda.jpg";
import Brazil from "./Brazil.jpg";
import Canada from "./Canada.jpg";
import Chile from "./Chile.jpg";
import China from "./China.jpg";
import Colombia from "./Colombia.jpg";
import CongoDemocraticRepublicofthe from "./Congo,DemocraticRepublicofthe.jpg";
import CostaRica from "./CostaRica.jpg";
import Cyprus from "./Cyprus.jpg";
import CzechRepublic from "./CzechRepublic.jpg";
import Denmark from "./Denmark.jpg";
import Egypt from "./Egypt.jpg";
import EU from "./EU.jpg";
import Finland from "./Finland.jpg";
import France from "./France.jpg";
import generic from "./generic.jpg";
import Germany from "./Germany.jpg";
import Greece from "./Greece.jpg";
import Hungary from "./Hungary.jpg";
import India from "./India.jpg";
import Indonesia from "./Indonesia.jpg";
import Iran from "./Iran.jpg";
import Iraq from "./Iraq.jpg";
import Ireland from "./Ireland.jpg";
import Israel from "./Israel.jpg";
import Italy from "./Italy.jpg";
import Japan from "./Japan.jpg";
import Kazakhstan from "./Kazakhstan.jpg";
import KoreaSouth from "./Korea,South.jpg";
import Latvia from "./Latvia.jpg";
import luxembourg from "./luxembourg.jpg";
import Macau from "./Macau.jpg";
import Malaysia from "./Malaysia.jpg";
import Mexico from "./Mexico.jpg";
import Morocco from "./Morocco.jpg";
import Netherlands from "./Netherlands.jpg";
import NewZealand from "./NewZealand.jpg";
import Nigeria from "./Nigeria.jpg";
import Norway from "./Norway.jpg";
import Pakistan from "./Pakistan.jpg";
import Peru from "./Peru.jpg";
import Philippines from "./Philippines.jpg";
import Poland from "./Poland.jpg";
import Portugal from "./Portugal.jpg";
import PuertoRico from "./PuertoRico.jpg";
import Qatar from "./Qatar.jpg";
import Romania from "./Romania.jpg";
import Russia from "./Russia.jpg";
import RussianFederation from "./RussianFederation.jpg";
import SaudiArabia from "./SaudiArabia.jpg";
import Singapore from "./Singapore.jpg";
import Slovakia from "./Slovakia.jpg";
import SouthAfrica from "./SouthAfrica.jpg";
import Spain from "./Spain.jpg";
import Sudan from "./Sudan.jpg";
import Sweden from "./Sweden.jpg";
import Switzerland from "./Switzerland.jpg";
import Taiwan from "./Taiwan.jpg";
import Thailand from "./Thailand.jpg";
import Turkey from "./Turkey.jpg";
import Ukraine from "./Ukraine.jpg";
import un from "./un.jpg";
import UnitedArabEmirates from "./UnitedArabEmirates.jpg";
import UnitedKingdom from "./UnitedKingdom.jpg";
import UnitedStates from "./UnitedStates.jpg";
import Venezuela from "./Venezuela.jpg";
import Vietnam from "./Vietnam.jpg";
import Yugoslavia from "./Yugoslavia.jpg";
export {
  Argentina,
  Australia,
  Austria,
  Bahrain,
  Bangladesh,
  Belgium,
  Bermuda,
  Brazil,
  Canada,
  Chile,
  China,
  Colombia,
  CongoDemocraticRepublicofthe,
  CostaRica,
  Cyprus,
  CzechRepublic,
  Denmark,
  Egypt,
  EU,
  Finland,
  France,
  generic,
  Germany,
  Greece,
  Hungary,
  India,
  Indonesia,
  Iran,
  Iraq,
  Ireland,
  Israel,
  Italy,
  Japan,
  Kazakhstan,
  KoreaSouth,
  Latvia,
  luxembourg,
  Macau,
  Malaysia,
  Mexico,
  Morocco,
  Netherlands,
  NewZealand,
  Nigeria,
  Norway,
  Pakistan,
  Peru,
  Philippines,
  Poland,
  Portugal,
  PuertoRico,
  Qatar,
  Romania,
  Russia,
  RussianFederation,
  SaudiArabia,
  Singapore,
  Slovakia,
  SouthAfrica,
  Spain,
  Sudan,
  Sweden,
  Switzerland,
  Taiwan,
  Thailand,
  Turkey,
  Ukraine,
  un,
  UnitedArabEmirates,
  UnitedKingdom,
  UnitedStates,
  Venezuela,
  Vietnam,
  Yugoslavia,
};

const countryObj = {
  Argentina: Argentina,
  Australia: Australia,
  Austria: Austria,
  Bahrain: Bahrain,
  Bangladesh: Bangladesh,
  Belgium: Belgium,
  Bermuda: Bermuda,
  Brazil: Brazil,
  Canada: Canada,
  Chile: Chile,
  China: China,
  Colombia: Colombia,
  "Congo,DemocraticRepublicofthe": CongoDemocraticRepublicofthe,
  CostaRica: CostaRica,
  Cyprus: Cyprus,
  CzechRepublic: CzechRepublic,
  Denmark: Denmark,
  Egypt: Egypt,
  EU: EU,
  Finland: Finland,
  France: France,
  generic: generic,
  Germany: Germany,
  Greece: Greece,
  Hungary: Hungary,
  India: India,
  Indonesia: Indonesia,
  Iran: Iran,
  Iraq: Iraq,
  Ireland: Ireland,
  Israel: Israel,
  Italy: Italy,
  Japan: Japan,
  Kazakhstan: Kazakhstan,
  "Korea,South": KoreaSouth,
  Latvia: Latvia,
  luxembourg: luxembourg,
  Macau: Macau,
  Malaysia: Malaysia,
  Mexico: Mexico,
  Morocco: Morocco,
  Netherlands: Netherlands,
  NewZealand: NewZealand,
  Nigeria: Nigeria,
  Norway: Norway,
  Pakistan: Pakistan,
  Peru: Peru,
  Philippines: Philippines,
  Poland: Poland,
  Portugal: Portugal,
  PuertoRico: PuertoRico,
  Qatar: Qatar,
  Romania: Romania,
  Russia: Russia,
  RussianFederation: RussianFederation,
  SaudiArabia: SaudiArabia,
  Singapore: Singapore,
  Slovakia: Slovakia,
  SouthAfrica: SouthAfrica,
  Spain: Spain,
  Sudan: Sudan,
  Sweden: Sweden,
  Switzerland: Switzerland,
  Taiwan: Taiwan,
  Thailand: Thailand,
  Turkey: Turkey,
  Ukraine: Ukraine,
  un: un,
  UnitedArabEmirates: UnitedArabEmirates,
  UnitedKingdom: UnitedKingdom,
  UnitedStates: UnitedStates,
  Venezuela: Venezuela,
  Vietnam: Vietnam,
  Yugoslavia: Yugoslavia,
};

/**
 * Changed the object's behavior to return the generic flag instead of `undefined`
 */
export const countryMap = new Proxy(countryObj, {
  get: (target, name) =>
    target.hasOwnProperty(name) ? target[name as keyof typeof target] : generic,
});
